<template>
  <div>
    <center class="loading-medium" v-if="loading">
      <loading></loading>
    </center>
    <div class="content content-new" v-else>
      <div class="container-fluid">
        <div
          v-if="!(message == '' || message == null)"
          class="alert alert-danger text-center custom-width alert-custom"
        >
          <strong>{{ message }}</strong>
        </div>
        <div v-else>
          <div class="row" style="margin-bottom: 10px">
            <div class="col-xs-3">
              <h3>Vendor Commodities</h3>
            </div>
            <div class="col-xs-6"></div>
            <div class="col-xs-3">
              <img
                :src="BankLogo"
                style="
                  height: 44px;
                  width: 195px;
                  float: right;
                  margin-left: 20px;
                "
              />
            </div>
          </div>
          <div class="form-group form-inline custom-width">
            <input
              type="search"
              class="form-control search-box"
              style="background-color: white"
              placeholder="Search"
              v-model="Search"
            />

            <select
              class="form-control"
              name="vendor"
              v-model="SelectedVendor"
              @change="ChangeVendor"
            >
              <option
                v-for="(option, index) in VENDORS"
                :key="index"
                v-bind:value="option.Id"
              >
                {{ option.Name }}
              </option>
            </select>
            <button
              class="btn btn-primary"
              @click="ChangePageSizeORSearch"
              style="margin-left: 4px"
            >
              Search
            </button>
            <button
              class="btn btn-primary"
              @click="ExportCSV"
              style="margin-left: 4px"
            >
              Export to CSV
            </button>
            <button
              class="btn btn-primary"
              style="margin-left: 4px"
              @click="Print"
            >
              Print
            </button>
            <div class="pull-right">
              <button class="btn btn-primary" @click="AddCommodity">
                Add/Remove Commodity
              </button>
            </div>
          </div>
          <div id="printable_commodities">
            <strong current-date></strong>
            <table class="table table-bordered ng-grid">
              <thead style="background: #efeeed">
                <tr>
                  <th>No.</th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Code')"
                      >Code</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Code'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Name')"
                      >Name</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Name'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Unit')"
                      >Unit</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Unit'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(com, index) in OrderBy"
                  :key="index"
                  :class="{ even: index + (1 % 2) == 0 }"
                >
                  <td>
                    {{
                      (SelectedPageSize == "ALL" ? 0 : SelectedPageSize) *
                        (currentPage - 1) +
                      (index + 1)
                    }}
                  </td>
                  <td>{{ com.Code }}</td>
                  <td>{{ com.Name }}</td>
                  <td>{{ com.Unit }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="custom-width">
            <div class="pull-left">
              <paginate
                ref="paginate"
                :page-count="PageCalculation"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :click-handler="clickCallback"
                :container-class="'pagination'"
              ></paginate>
            </div>
            <div class="btn-group form-inline pull-right pager">
              <label>Page Size :</label>
              <select
                v-model="SelectedPageSize"
                class="form-control input-sm"
                @change="ChangePageSizeORSearch"
              >
                <option v-for="(option, index) in PageSize" :key="index">
                  {{ option.key }}
                </option>
              </select>
            </div>
          </div>
          <pre class="custom-width">
Page:{{ currentPage }} / {{ PageCalculation }} </pre
          >
          <div class="form-group form-inline custom-width">
            <button class="btn btn-primary" @click="GoBack">Back</button>
          </div>
        </div>
      </div>
    </div>
    <vendorcommodity
      v-if="showModal"
      @Close="closeModal"
      :VendorId="parseInt(VendorId)"
    ></vendorcommodity>
  </div>
</template>


<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import vendorcommodity from "./VendorsCommodity";
export default {
  data() {
    return {
      SelectedPageSize: 10,
      SelectedVendor: null,
      VendorId: null,
      currentPage: 1,
      Search: null,
      currentSort: "Name",
      curentSortOrder: "asc",
      showModal: false,
    };
  },
  components: {
    vendorcommodity,
  },
  methods: {
    ChangePageSizeORSearch() {
      this.currentPage = 1;
      this.ChnageUrl();
      this.GetData();
    },
    clickCallback: function (page) {
      if (page) {
        this.currentPage = page;
        this.ChnageUrl();
        this.GetData();
      }
    },
    ChangeVendor() {
      this.VendorId = this.SelectedVendor;
      this.GetData();
    },
    ChangeOrder(key) {
      if (key == this.currentSort) {
        this.curentSortOrder = this.curentSortOrder == "asc" ? "desc" : "asc";
      } else {
        this.curentSortOrder = "asc";
      }
      this.currentSort = key;
      this.ChnageUrl();
    },
    AddCommodity() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.GetData();
    },
    ChnageUrl() {
      var Url =
        "?page=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&dir=" +
        this.curentSortOrder +
        "&sort=" +
        this.currentSort;
      this.$router.push({ path: "" + Url });
    },

    ExportCSV() {
      this.ObjectToCSV(" Vendor Commodities.csv", this.VendorCommodities, [
        "Code",
        "Name",
        "Unit",
      ]);
    },
    GoBack() {
      this.$router.go(-1);
    },
    Print() {
      this.printData("printable_commodities", "Vendor Commodities");
    },
    GetData() {
      var Url =
        "?VendorId=" +
        this.VendorId +
        "&currentpage=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search);

      var vm = this;
      this.$store
        .dispatch(ACTIONS.VENDORS_COMMODITIES_GETALL, Url)
        .then((res) => {
          this.$refs.paginate.selected = vm.currentPage - 1;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeMount() {
    if (this.$route.query) {
      if (this.$route.query.hasOwnProperty("pagesize")) {
        this.SelectedPageSize = this.$route.query["pagesize"];
      }
      if (this.$route.query.hasOwnProperty("search")) {
        this.Search = this.$route.query["search"];
      }
      if (this.$route.query.hasOwnProperty("page")) {
        this.currentPage = this.$route.query["page"];
      }
      if (this.$route.query.hasOwnProperty("sort")) {
        this.currentSort = this.$route.query["sort"];
      }
      if (this.$route.query.hasOwnProperty("dir")) {
        this.curentSortOrder = this.$route.query["dir"];
      }
    }
    this.VendorId = this.$route.params.id;

    this.SelectedVendor = this.$route.params.id;
    this.GetData();
  },
  computed: {
    ...mapGetters({
      PageSize: "PageSize",
      VendorCommodities: "VendorCommodities",
      VENDOR: "VendorCommoditiesVendor",
      VENDORS: "VendorCommoditiesVendors",
      TotalRecords: "VendorCommoditiesTotalPages",
      message: "VendorCommoditieserrorMessage",
      loading: "VendorCommoditiesloading",
      BankLogo: "GETBANKLOGO",
    }),
    PageCalculation() {
      var count = Math.ceil(this.TotalRecords / this.SelectedPageSize);
      return count > 0 ? count : 1;
    },
    OrderBy() {
      var data = [...this.VendorCommodities];
      var SortedArray = this.Sort(data, this.currentSort, this.curentSortOrder);
      if (!this.SelectedPageSize || this.SelectedPageSize == "ALL") {
        this.SelectedPageSize = SortedArray.length;
      }
      if (!this.currentPage) {
        this.currentPage = 1;
      }
      var sp = parseInt(this.SelectedPageSize); // selected Page
      var cp = parseInt(this.currentPage); // current page
      // var _pageData = this.Pagination(SortedArray, sp, cp);
      return this.Pagination(SortedArray, sp, cp);
    },
  },
};
</script>